import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-first-password-modal',
  templateUrl: './first-password-modal.component.html',
  styleUrls: ['./first-password-modal.component.scss'],
})
export class FirstPasswordModalComponent {
  constructor(
    private dialogRef: MatDialogRef<FirstPasswordModalComponent>,
    private router: Router,
  ) {}

  close() {
    this.dialogRef.close();
  }

  changePassword() {
    this.dialogRef.close();
    this.router.navigate(['/user/profile']);
  }
}
